module.exports = '4.13.2';



// WEBPACK FOOTER //
// ./src/version.js